'use strict';

module.exports = require('./timers').setInterval;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/utils/set-interval.js
 ** module id = 799
 ** module chunks = 0 1
 **/